













































































































































import Vue, {PropOptions} from 'vue';

import NOC from '@/class/common/const';
import * as NOCArray from '@/personal/array';
import CustomHolidayModal from '@/parts/setting/workstyle/CustomHolidayModal.vue';
import * as models from '@/class/models/views/setting/workstyle';
import { ISelectOption } from '@/class/models/typed/wild';

import VariableInput, {IVariableInput, INPUT_TYPE} from '@/components/util/VariableInput.vue';

// validation
import * as validation from '@/personal/validation';

// datepicker
import DatePicker from 'vuejs-datepicker';
import {ja} from 'vuejs-datepicker/dist/locale';

const DAY_OF_WEEK_SELECT_OPTIONS: ISelectOption[] = NOCArray.DAY_OF_WEEK.map((v) => (
  {
    text: v.text + '曜日',
    value: v.value,
  }
));

export default Vue.extend({
  name: 'WorkstyleEditer',
  components: {
    VariableInput,
    CustomHolidayModal,
    DatePicker,
  },
  props: {
    editWorkstyle: Object as PropOptions<models.IWorkstyle>,
    editWorkstyleID: Number,
    customHolidays: Array as PropOptions<models.ICustomHoliday[]>,
    customHolidayUseds: Array as PropOptions<models.ICustomHolidayUsed[]>,
    fncRegistCustomHoliday: Function,
    fncEditCustomHoliday: Function,
    fncDeleteCustomHoliday: Function,
    registCount: Number,
  },
  computed: {
    DAY_OF_WEEK(): string[] {
      return [
        NOC.SETTING.HOLIDAY.MON,
        NOC.SETTING.HOLIDAY.TUE,
        NOC.SETTING.HOLIDAY.WED,
        NOC.SETTING.HOLIDAY.THU,
        NOC.SETTING.HOLIDAY.FRI,
        NOC.SETTING.HOLIDAY.SAT,
        NOC.SETTING.HOLIDAY.SUN,
        NOC.SETTING.HOLIDAY.JAPAN,
      ];
    },
    CUTOFFDAY_SELECT(): number {
      return NOC.SETTING.CUTOFFDAY.VALUE.SELECT;
    },
  },
  watch: {
    editWorkstyleID() {
      this.seteditData();
    },
    cutoffDayType() {
      this.items[5].required = false;
      if (this.cutoffDayType === NOC.SETTING.CUTOFFDAY.VALUE.SELECT) {
        this.items[5].required = true;
      }
    },
    registCount() {
      this.onClickWorkstyleEmit();
    },
  },
  data() {
    return {
      editData: new models.CWorkstyle(),
      editCustomHolidayUseds: [] as models.ICustomHolidayUsed[],
      cutoffDayType: 0,
      cutoffDay: 1,
      editCustomHoliday: new models.CCustomHoliday(),
      editCustomHolidayFlag: false,
      items: [
        {key: 'name', name: '就業形態名', type: INPUT_TYPE.TEXT, required: true, error: '', max: 20},
        {key: 'startTime', name: '始業時間', type: INPUT_TYPE.TIME, required: true, error: '', step: 900},
        {key: 'endTime', name: '終業時間', type: INPUT_TYPE.TIME, required: true, error: '', step: 900},
        {key: 'restTime', name: '休憩時間', type: INPUT_TYPE.TIME, required: true, error: '', step: 900},
        {key: 'cutoffDayType', name: '勤怠締め日', type: INPUT_TYPE.SELECT, required: true, error: '', options: NOCArray.CUTOFFDAY},
        {key: 'cutoffDay', name: '', type: INPUT_TYPE.NUMBER, required: false, error: '', min: 1, max: 28},
        {key: 'weekFirst', name: '週の起算日', type: INPUT_TYPE.RADIO, required: false, error: '', options: NOCArray.DAY_OF_WEEK},
        {key: 'legalHoliday', name: '', type: INPUT_TYPE.SELECT, required: false, error: '', options: NOCArray.LEGAL_HOLIDAY},
        {key: 'weekFirstCopy', name: '', type: INPUT_TYPE.SELECT, required: false, error: '', options: DAY_OF_WEEK_SELECT_OPTIONS},
      ] as IVariableInput[],
      cutoffDayError: '',
      newFlag: false,
      DatePickerDate: 'M月d日',
      ja,
    };
  },
  directives: {
    DatePicker,
  },
  created() {
    this.seteditData();
  },
  methods: {
    onChangeCutoffDay() {
    },
    // editDataに値を設定
    seteditData() {
      // propsデータを取得
      this.editData = JSON.parse(JSON.stringify(this.editWorkstyle));

      // 締め日を設定
      const cd = this.editData.cutoffDay;

      if (NOCArray.checkOptionsText(NOCArray.CUTOFFDAY, cd)) {
        this.cutoffDayType = cd;
      } else {
        this.cutoffDayType = NOC.SETTING.CUTOFFDAY.VALUE.SELECT;
        this.cutoffDay = cd;
      }

      // カスタム休日設定
      this.editCustomHolidayUseds = JSON.parse(JSON.stringify(this.customHolidayUseds
        .filter((v: models.ICustomHolidayUsed) => (v.workstyleID === this.editWorkstyleID))));
    },
    // カスタム休日 編集処理
    onClickEditCusutomHoliday(customHoliday: models.CCustomHoliday) {
      this.editCustomHoliday = JSON.parse(JSON.stringify(customHoliday));
      this.editCustomHolidayFlag = true;
      this.newFlag = false;
    },
    // カスタム休日 新規作成処理
    onClickNewCustomHoliday() {
      this.editCustomHoliday = new models.CCustomHoliday();
      this.editCustomHolidayFlag = true;
      this.newFlag = true;
    },
    // カスタム休日 登録処理
    async onClickRegistCustomHoliday(customHoliday: models.CCustomHoliday) {
      let result = false;
      // idの有無によって処理を変更
      if (customHoliday.customHolidayID === 0) {
        result = await this.fncRegistCustomHoliday(customHoliday);
      } else {
        // await this.$emit('editCustomHoliday', customHoliday);
        result = await this.fncEditCustomHoliday(customHoliday);
      }
      // 問題なく更新できた場合閉じる
      this.editCustomHolidayFlag = !result;
    },
    // カスタム休日 削除処理
    async onClickDeleteCustomHoliday(customHoliday: models.CCustomHoliday) {
      await this.fncDeleteCustomHoliday(customHoliday.customHolidayID);
      this.$data.editCustomHolidayFlag = false;
    },
    // 就業形態 登録または編集処理
    onClickWorkstyleEmit() {

      // 値の設定
      let cd = this.cutoffDayType;
      this.cutoffDayError =　'';

      // 日付選択の場合はその値を取得
      if ( cd === NOC.SETTING.CUTOFFDAY.VALUE.SELECT) {
        this.cutoffDay = Number(this.cutoffDay);
        if (1 > this.cutoffDay || this.cutoffDay >= 29) {
          // this.cutoffDayError = '締め日を1日から28日の間で入力してください。';
          return;
        }
        cd = this.cutoffDay;
      }
      this.editData.cutoffDay = cd;
      // validation
      if (cd === NOC.SETTING.CUTOFFDAY.VALUE.LAST) {
        if (validation.checkValues(this.editData, this.items.slice(0, 3)) > 0) {
          return;
        }
      } else {
        if (validation.checkValues(this.editData, this.items) > 0) {
          return;
        }
      }

      const startTime = Number(this.$data.editData.startTime.split(':').slice(0, 2).join(''));
      const endTime = Number(this.$data.editData.endTime.split(':').slice(0, 2).join(''));
      const restTime = Number(this.$data.editData.restTime.split(':').slice(0, 2).join(''));

      // if (startTime < endTime) {
      //  this.$data.items.filter((x: IVariableInput) => x.key === 'endTime')[0].error = '始業時間よりも早く設定されています。';
      //  return;
      // }
      if (startTime === endTime) {
        this.$data.items.filter((x: IVariableInput) => x.key === 'startTime')[0].error = '始業時間が終業時間同じです。';
        return;
      }

      if (startTime < endTime ) {
        if ((endTime - startTime -  restTime) <= 0) {
          this.$data.items.filter((x: IVariableInput) => x.key === 'startTime')[0].error = '就業時間が0以下です。';
          return;
        }
      } else {
        if ((endTime + 2400 - (startTime + restTime)) <= 0) {
          this.$data.items.filter((x: IVariableInput) => x.key === 'startTime')[0].error = '就業時間が0以下です。';
          return;
        }
      }

      // 出力データ設定
      const emitData: models.VEditWorkStyle = {
        workstyle:  this.editData,
        customHolidayUseds: this.editCustomHolidayUseds,
        specialLeaveUseds: [],
      };

      // 処理実行
      this.$emit('regist', emitData);

    },
    // 就業形態を削除
    async onClickDelete() {
      await this.$emit('delete', this.editData.workstyleID);
    },
  },
});
